const NOT_ON_PANEL_PATTERN = /not on .*panel/i;

// PCRS explicitly reports the patient is not on the GP's panel — a review now
// would be rejected ("Patient not on GP Panel"). A definitive error, surfaced
// on its own regardless of any dates or GP-number heuristics.
export const isNotOnPanelError = (errors = []) =>
  (errors ?? []).some(
    (message) =>
      typeof message === "string" && NOT_ON_PANEL_PATTERN.test(message)
  );
